import React, { Fragment } from 'react';
import Type from 'prop-types';
import { isEmpty } from 'lodash';
import { Divider } from '@material-ui/core';
import { sortByOrder } from 'utils/sorter';
import CaseSide from '../CaseSide';

const sideOrder = ['plaintiff', 'respondent', 'thirdPerson', 'otherPerson'];

const CaseSides = props => {
  const { sides } = props;

  const nameOfSides = Object.keys(sides);
  const sortedNameOfSides = sortByOrder(nameOfSides, sideOrder);

  if (isEmpty(sides)) {
    return null;
  }

  return sortedNameOfSides.map(sideName => {
    const side = sides[sideName];

    return (
      <Fragment key={sideName}>
        <CaseSide sideName={sideName} organizations={side} />
        <Divider />
      </Fragment>
    );
  });
};

CaseSides.propTypes = {
  sides: Type.shape({
    plaintiff: CaseSide.propTypes.organizations.isRequired,
    respondent: CaseSide.propTypes.organizations.isRequired,
    thirdPerson: CaseSide.propTypes.organizations,
    otherPerson: CaseSide.propTypes.organizations,
  }).isRequired,
};

export default CaseSides;
